import React from 'react';

const Services = () => {
    return (
        <section className="hiro-section" id="services">
            <div className="container">
                <div className="service-section">
                    <h2 className="section-title career-section-title">Streamlined Workforce Solutions</h2>
                    <div className="row">
                        <div className="col-md-4 mb-4 mb-md-0 wow fadeInUp">
                            <h6 className="service-category-title">Onboarding</h6>
                            <ul className="service-list list-group list-group-flush">
                                <li className="list-group-item">Register Workers</li>
                                <li className="list-group-item">Provide Availability</li>
                                <li className="list-group-item">Set Rate per Hour/Day</li>
                                <li className="list-group-item">Verify Worker Profiles</li>
                               
                            </ul>
                        </div>
                        <div className="col-md-4 mb-4 mb-md-0 wow fadeInUp">
                            <h6 className="service-category-title">Hiring</h6>
                            <ul className="service-list list-group list-group-flush">
                                <li className="list-group-item">Post Job Listing</li>
                                <li className="list-group-item">Select one or more workers</li>
                                <li className="list-group-item">Quick and seamless hiring process</li>
                                <li className="list-group-item">Workers Notified and accept job via the app</li>
                               
                            </ul>
                        </div>
                        <div className="col-md-4 mb-4 mb-md-0 wow fadeInUp">
                            <h6 className="service-category-title">Benefits</h6>
                            <ul className="service-list list-group list-group-flush">
                                {/* <li className="list-group-item">Insurance Coverage during work hours</li> */}
                                <li className="list-group-item">Peace of mind for both workers and employers</li>
                                <li className="list-group-item">Verified worker profiles ensure quality</li>
                                <li className="list-group-item">Access to a wide pool of workers</li>
                               
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Services;
